import { render } from "./CovidCertificate.vue?vue&type=template&id=314f5eb5"
import script from "./CovidCertificate.vue?vue&type=script&lang=js"
export * from "./CovidCertificate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__